import React, { useState, useMemo } from 'react';
import { Box, Paper, Tabs, Tab, CircularProgress, Container, Alert } from '@mui/material';
import { AccessTime, History } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import BillingPanelHeader from '../components/BillingPanelHeader';
import QueueTab from '../components/QueueTab';
import HistoryTab from '../components/HistoryTab';
import { useBillingPanel } from '../components/useBillingPanel';
import {

  CheckCircleOutline,
  Error,
  Warning,
  HourglassEmpty,
} from '@mui/icons-material';

// Função para obter ícone e cor do status
export const getStatusBadge = (status?: string) => {

  switch (status) {
    case 'Não há pedido emitido':
      return { icon: <Error />, color: 'error' as const, label: 'Não há pedido' };
    case 'Não liberado pelo financeiro':
      return { icon: <Warning />, color: 'warning' as const, label: 'Pendente Financeiro' };
    case 'Não liberado pelo comercial':
      return { icon: <Warning />, color: 'warning' as const, label: 'Pendente Comercial' };
    case 'Não liberado pelo transporte':
      return { icon: <Warning />, color: 'warning' as const, label: 'Pendente Transporte' };
    case 'Pedido liberado':
      return { icon: <CheckCircleOutline />, color: 'success' as const, label: 'Liberado' };
    default:
      return { icon: <HourglassEmpty />, color: 'default' as const, label: 'Desconhecido' };
  }
};


const BillingPanelPage: React.FC = () => {
  const { base } = useParams < { base: string } > ();
  const [tabValue, setTabValue] = useState(0);

  const {
    queue,
    history,
    loading,
    connected,
    actionLoading,
    error,
    handleFinishDriver,
    handleCancelDriver,
    fetchHistory,
    USE_MOCK,
    selectedDate,
    setSelectedDate,
  } = useBillingPanel(base);

  // Filtra histórico de pedidos finalizados/cancelados de acordo com a data selecionada
  const filteredHistory = useMemo(() => {
    const today = selectedDate ? selectedDate : new Date();
    return history.filter((driver) => {
      if (!driver.finish_time) return false;
      if (!['Cancelado', 'Finalizado'].includes(driver.status)) return false;

      const finish = new Date(driver.finish_time);
      // Ajuste para fuso horário brasileiro (GMT-3)
      finish.setHours(finish.getHours() - 3);

      return (
        finish.getFullYear() === today.getFullYear() &&
        finish.getMonth() === today.getMonth() &&
        finish.getDate() === today.getDate()
      );
    });
  }, [history, selectedDate]);



  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #004792 0%, #FFC300 100%)',

        py: 4,
        px: 2,
      }}
    >
      {(error && error !== 'Nenhum motorista na fila') && <Alert severity="error">{error}</Alert>}

      {USE_MOCK && (
        <Alert severity="info" sx={{ mb: 3 }}>
          Os dados exibidos são simulados. As ações funcionam apenas localmente.
        </Alert>
      )}

      <Container maxWidth="xl">
        <Paper elevation={4} sx={{ p: { xs: 2, sm: 4 }, mb: 4, borderRadius: 3 }}>
          <BillingPanelHeader
            connected={connected}
          />

          <Tabs
            value={tabValue}
            onChange={(_, v) => setTabValue(v)}
            centered
            indicatorColor="primary"
            textColor="primary"

            sx={{ mb: 3 }}
          >
            <Tab label={`Em Fila (${queue.length})`} icon={<AccessTime />} />
            <Tab label={`Histórico (${filteredHistory.length})`} icon={<History />} />
          </Tabs>


          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
              <CircularProgress />
            </Box>

          ) : (
            <>

              <Box hidden={tabValue !== 0}>
                <QueueTab
                  queue={queue}

                  actionLoading={actionLoading}
                  onFinish={handleFinishDriver}
                  onCancel={handleCancelDriver}
                  error={error}

                />
              </Box>
              <Box hidden={tabValue !== 1}>
                <HistoryTab

                  history={history}

                  selectedDate={selectedDate}
                  setSelectedDate={(date) => {
                    setSelectedDate(date);
                    fetchHistory(date || null);
                  }}
                  fetchHistory={fetchHistory}
                />


              </Box>
            </>
          )}
        </Paper>
      </Container>
    </Box>
  );

};

export default BillingPanelPage;



